define('toolkit/b-spinner/b-spinner', [
		'toolkit/b-toolkit/b-toolkit',
		'mrg-device-tools'
],
function(toolkit, mrgDeviceTools) {
	'use strict';

	var USER_AGENT = mrgDeviceTools.matchUserAgent(navigator.userAgent);

	return toolkit.create('b-spinner', {
		init: function() {
			if (this._isSafari()) {
				this.toggleMod('no-svg', true);
			}
		},

		deferredInit: true,

		/**
		 * Сафари?
		 * @returns {boolean}
		 * @private
		 */
		_isSafari: function() {
			return USER_AGENT && USER_AGENT.safari;
		}
	});
});
